module.exports = __webpack_public_path__ + "static/media/positive-icon.051869b0.svg";